import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import Template from "./Template";


const Summary = props => (
  <Template
    title="Dziękujemy!"
    navigationRight={[
      <button
        onClick={() => {
          props.history.push("/");
          window.scrollTo(0, 0);
        }}
        className="button is-danger is-medium"
      >
        Strona główna
      </button>
    ]}
    navigationLeft={[
      <a className="button is-danger is-medium" href="https://sklep.wszystkiegoslodkiego.pl">
        Sklep internetowy Dr. Oetker
      </a>,
      <a className="button is-danger is-medium" href="https://www.oetker.pl/o-firmie-dr-oetker/badania-sensoryczne">
        Kontakt
      </a>
    ]}
  >
    <p>
      DZIĘKUJEMY ZA WYPEŁNIENIE ANKIETY I GOTOWOŚĆ DO UCZESTNICZENIA W TESTACH
      PRODUKTÓW FIRMY DR. OETKER
    </p>

    <p>
      Na podany w formularzu przez Państwa adres e-mail została wysłana wiadomość potwierdzająca rejestrację.
    </p>

    <p>
      Zapraszamy również do odwiedzenia naszego sklepu internetowego.
      <br /><br /><br />
    </p>
  </Template>
);
Summary.propTypes = {
  history: PropTypes.shape().isRequired
};
export default withRouter(Summary);



// WEBPACK FOOTER //
// ./src/components/pages/Summary.js